module.exports = __webpack_public_path__ + "static/bgless3.24b75304.png";